import { Client, ThreadState } from "@langchain/langgraph-sdk";

export const createClient = () => {
  const apiUrl = import.meta.env.VITE_LANGGRAPH_DEPLOYMENT_URL;
  if (!apiUrl) {
    // Handle the case where the URL might be missing
    console.error("VITE_LANGGRAPH_DEPLOYMENT_URL is not set.");
    throw new Error("API URL not configured.");
  }
  if (!import.meta.env.VITE_LANGSMITH_API_KEY) {
    throw new Error("LANGSMITH_API_KEY is not set.");
  }
  return new Client({
    apiUrl,
    defaultHeaders: {
      // pass the user auth token
      "X-API-Key": import.meta.env.VITE_LANGSMITH_API_KEY,
    },
  });
};

export const invokeAssistantWait = async (
  client: Client,
  graphId: string,
  payload: Record<string, any>
): Promise<ThreadState["values"]> =>
  await client.runs.wait(null, graphId, payload);

type Topic = {
  topic: string;
  body: string;
};

export type GenTopicsOutput = {
  topics: Topic[];
};

type BrandProfile = {
  title: string;
  summary: string;
  industry: string;
  niche: string;
  audience: string;
  pain_points: string;
  objectives: string;
  tone: string;
  language: string;
  contact_phone: string | null;
  contact_email: string | null;
  website: string | null;
  ctas: string[];
  social_handle: string | null;
};

type GenBrandProfileOutput = {
  brand_profile: BrandProfile;
  topics: Topic[];
};

export const genTopics = async ({
  business_id,
  url,
}: {
  business_id: string;
  url: string;
}): Promise<GenTopicsOutput | undefined> => {
  const client = createClient();
  const payload = {
    input: {
      url,
      should_extract_brand_profile: false,
    },
    metadata: {
      business_id: business_id,
    },
  };
  const response = await invokeAssistantWait(client, "gen_topics", payload);
  return response as GenTopicsOutput;
};
